import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import { getHomeRoute } from '../../helpers';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

const NavBar = ({ className, noLogoLink }) => {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
    } catch (e) {
        // meh, leave it empty
    }

    return (
        <Header
            containerClassName={className}
            logoClassName={style.logo}
            primaryNavLinks={primaryNavLinks}
            showAlertAction={false}
            isNeverCollapse={Fortress.user.acting.role.handle === 'orgAdmin'}
            showHomeAction={false}
            logoLink={noLogoLink ? null : getHomeRoute()}
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
    noLogoLink: false,
};

NavBar.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
};

export default NavBar;
